<ion-header>
	<app-account-toolbar (back)="goBack()" src="/assets/icons-menu-modal/agb.svg" title="menu_popover.terms"></app-account-toolbar>
</ion-header>
